import React from "react";
import PluginBridge from "../index";

/**
 * Slot de botoes ao lado do input de mensagem do chat.
 *
 * Plugins declaram actions com `slot: "message-input"` no metadata.
 * Aceita resultTypes: insert-text, dialog, text, html, json.
 *
 * Props:
 *   ticketId      — id do ticket ativo
 *   contactId     — id do contato do ticket
 *   channel       — canal do ticket (usado para filtrar actions por canal)
 *   whatsappId    — id da conexão do ticket
 *   onInsertText  — callback para inserir texto no input (resultType: "insert-text")
 */
export default function MessageInputSlot({ ticketId, contactId, channel, whatsappId, onInsertText }) {
  return (
    <PluginBridge
      slot="message-input"
      as="buttons"
      context={{ ticketId, contactId, channel, whatsappId }}
      onInsertText={onInsertText}
    />
  );
}
